/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {findUnits} from '../api'

export const useMutationFindUnits = createReactQueryMutationHook('findUnits', findUnits)
